import React from "react";

import {FIELD_TYPE, FORMAT_TIME, tabKeys, TT_PHIEU_VTYT} from "types/enums";

import { DataFormField } from "types/models/input-field-type";

import {ColumnProps} from "../../../../../types/models";
import {listGender} from "../../../../../data/list";
import {trangThaiPKOptions} from "../../../../../assets/constants/select-catagory-options";
import {formatToCurrencyType} from "../../../../../helper/common";
import dayjs from 'dayjs';

const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER,DATE_DISABLE_NO_DAY } = FIELD_TYPE;
const listMonths = [];
for (let month = 1; month <= 12; month++) {
  listMonths.push({
    value: month,
    label: `Tháng ${month}`,
  });
}
const listDaoTaoLe = [
  {
    value: 1,
    label: "Có",
  },
  {
    value: 0,
    label: "Không",
  },
];
//--------------------------------------------------------
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 2020;
const endYear = currentYear + 100;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}
const  allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    fixed: "left",
    width: 20,
    align: "center",
    isResizable: true,
  },
  {
    title: "Mã NV",
    key: "maNhanVien",
    show: true,
    dataIndex: "maNhanVien",
    width: 60,
    align: "left",
    isResizable: true,
  },
  {
    title: "Họ tên nhân viên",
    key: "tenNhanVien",
    show: true,
    dataIndex: "tenNhanVien",
    width: 130,
    align: "left",
    isResizable: true,
    fixed: "left",
  },
  {
    title: "TG đào tạo từ",
    key: "thoiGianDaoTaoCuaKhoaDaoTao",
    show: true,
    dataIndex: "thoiGianDaoTaoCuaKhoaDaoTao",
    width: 90,
    align: "center",
    isResizable: true,
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },
  {
    title: "TG đào tạo đến",
    key: "thoiGianDaoTaoDenCuaKhoaDaoTao",
    show: true,
    dataIndex: "thoiGianDaoTaoDenCuaKhoaDaoTao",
    width: 90,
    align: "center",
    isResizable: true,
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },
  {
    title: "Kết quả đào tạo",
    key: "ketQuaDaoTao",
    show: true,
    dataIndex: "ketQuaDaoTao",
    width: 90,
    align: "center",
    isResizable: true,
  },
  {
    title: "Đào tạo liên tục",
    key: "daoTaoLienTuc",
    show: true,
    dataIndex: "daoTaoLienTuc",
    width: 90,
    isResizable: true,
    align: "center",
  },
  {
    title: "Nhân viên đóng",
    key: "nhanVienDong",
    show: true,
    dataIndex: "nhanVienDong",
    width: 90,
    isResizable: true,
    align: "right",
    render(value, record, index) {
        return <>{formatToCurrencyType(value)}</>;
      },
  },
  {
    title: "Công ty đóng",
    key: "congTyDong",
    show: true,
    dataIndex: "congTyDong",
    width: 90,
    isResizable: true,
    align: "right",
    render(value, record, index) {
        return <>{formatToCurrencyType(value)}</>;
      },
  },
];

const itemsInputField: DataFormField[] = [
  {
    type: COMBO_BOX,
    label: "Tên nhân viên",
    name: "maNhanVien",
    disable: false,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "thoiGianDaoTaoCuaKhoaDaoTao",
    label: "Thời gian đào tạo từ",
    disable: false,
    optionsTime: {showTime: true, format: FORMAT_TIME.dayFull},
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "thoiGianDaoTaoDenCuaKhoaDaoTao",
    label: "Thời gian đào tạo đến",
    disable: false,
    optionsTime: {showTime: true, format: FORMAT_TIME.dayFull},
  },
  {
    type: COMBO_BOX,
    name: "tenKhoaDao",
    label: "Tên khóa đào tạo",
    disable: false,
  },
  {
    type: COMBO_BOX,
    name: "daoTaoLienTuc",
    label: "Đào tạo liên tục",
    disable: false,
    options: [
        { value: 1, label: "Có" },
        { value: 0, label: "Không" },
      ],
  },
  {
    type: COMBO_BOX,
    name: "daoTaoLeSearch",
    expand: false,
    label: "Đào tạo lẻ",
    options: listDaoTaoLe,
  },
];

export { allColumns, itemsInputField };
